module.exports = __webpack_public_path__ + "img/indicate.d69bdc84.png";